export default __webpack_public_path__ + "static/media/page-visited.69274315.svg";